import { defineComponent } from 'vue';
import AddressForm from '@/components/Base/Forms/AddressForm.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import BaseEmailInput from '@/components/Base/Forms/Inputs/BaseEmailInput.vue';
import BasePasswordInput from '@/components/Base/Forms/Inputs/BasePasswordInput.vue';
import SwitchToggle from '@/components/Base/Forms/Inputs/SwitchToggle.vue';
import eventBus from '@/services/EventBus';
export default defineComponent({
    name: 'address-block',
    components: {
        SwitchToggle,
        BasePasswordInput,
        BaseEmailInput,
        AddressForm,
    },
    data() {
        return {
            edit_shipping_address: null,
            edit_billing_address: null,
            use_billing_address: false,
            edit_email: null,
        };
    },
    computed: Object.assign(Object.assign(Object.assign(Object.assign({}, mapGetters('blue', {
        shippingAddress: 'shippingAddress',
        billingAddress: 'billingAddress',
        useBillingAddress: 'useBillingAddress',
        email: 'email',
        cartTotals: 'cartTotals',
    })), mapGetters('account', {
        isLogin: 'isLogin',
    })), mapState('blue', {
        cartErrors: 'cartErrors',
        guestRegistrationData: 'guest_registration_data',
    })), { current_shipping_address: {
            get: function () {
                var _a;
                return (_a = this.edit_shipping_address) !== null && _a !== void 0 ? _a : this.shippingAddress;
            },
            set: function (changeAddress) {
                this.edit_shipping_address = Object.assign({}, changeAddress);
                this.edit_shipping_address.id = undefined;
            },
        }, shippingAddressErrors() {
            var _a, _b;
            if (!((_b = (_a = this.cartErrors) === null || _a === void 0 ? void 0 : _a.addresses) === null || _b === void 0 ? void 0 : _b.shipping)) {
                return undefined;
            }
            return this.cartErrors.addresses.shipping;
        }, current_billing_address: {
            get: function () {
                var _a;
                return (_a = this.edit_billing_address) !== null && _a !== void 0 ? _a : this.billingAddress;
            },
            set: function (changeAddress) {
                this.edit_billing_address = Object.assign({}, changeAddress);
                this.edit_billing_address.id = undefined;
            },
        }, billingAddressErrors() {
            var _a, _b;
            if (!((_b = (_a = this.cartErrors) === null || _a === void 0 ? void 0 : _a.addresses) === null || _b === void 0 ? void 0 : _b.billing)) {
                return undefined;
            }
            return this.cartErrors.addresses.billing;
        }, current_email: {
            get: function () {
                var _a;
                return (_a = this.edit_email) !== null && _a !== void 0 ? _a : this.email;
            },
            set: function (new_email) {
                this.edit_email = new_email;
            },
        }, shouldRegister: {
            get() {
                return this.guestRegistrationData.shouldRegister;
            },
            set(shouldRegister) {
                this.storeShouldRegister(shouldRegister);
            },
        }, guest_password: {
            get: function () {
                var _a;
                return (_a = this.guestRegistrationData.password) !== null && _a !== void 0 ? _a : '';
            },
            set: function () {
                return;
            },
        }, emailError() {
            var _a;
            if (!((_a = this.cartErrors) === null || _a === void 0 ? void 0 : _a.email)) {
                return undefined;
            }
            //            return typeof this.cartErrors.email === 'string' ? [this.cartErrors.email] : this.cartErrors.email;
            // message should be another
            return ['Schön, dich wieder zu sehen. Log dich einfach ein!'];
        } }),
    methods: Object.assign(Object.assign(Object.assign({ autoFinishShippingAddress(changeAddress) {
            this.current_shipping_address = changeAddress;
            this.saveShippingAddress(false);
        },
        autoFinishBillingAddress(changeAddress) {
            this.current_billing_address = changeAddress;
            this.saveBillingAddress(false);
        },
        saveShippingAddress(storeAsDefault) {
            this.storeShippingAddress({
                address: this.current_shipping_address,
                storeAsDefault: storeAsDefault,
                shippingAddressIsBillingAddress: !this.use_billing_address,
            })
                .then((result) => {
                if (storeAsDefault) {
                    eventBus.emit('openInfoPopup', {
                        icon: 'success',
                        headline: 'Adresse gespeichert',
                        message: 'Die Adressänderung wurde erfolgreich übernommen.',
                    });
                }
                return result;
            })
                .catch(() => {
                if (storeAsDefault) {
                    eventBus.emit('openInfoPopup', {
                        icon: 'warning',
                        headline: 'Das hat leider nicht geklappt',
                        message: 'Die Adressänderung wurde nicht durchgeführt',
                    });
                }
            });
        },
        saveBillingAddress(storeAsDefault) {
            this.storeBillingAddress({
                address: this.current_billing_address,
                storeAsDefault: storeAsDefault,
            })
                .then((result) => {
                if (storeAsDefault) {
                    eventBus.emit('openInfoPopup', {
                        icon: 'success',
                        headline: 'Adresse gespeichert',
                        message: 'Die Adressänderung wurde erfolgreich übernommen.',
                    });
                }
                return result;
            })
                .catch(() => {
                if (storeAsDefault) {
                    eventBus.emit('openInfoPopup', {
                        icon: 'warning',
                        headline: 'Das hat leider nicht geklappt',
                        message: 'Die Adressänderung wurde nicht durchgeführt',
                    });
                }
            });
        },
        resetValidCartState() {
            this.setValidCartState(null);
        } }, mapActions('blue', {
        storeShippingAddress: 'SET_SHIPPING_ADDRESS',
        storeBillingAddress: 'SET_BILLING_ADDRESS',
        toggleBillingAddressUsage: 'TOGGLE_BILLING_ADDRESS_USAGE',
        storeEmail: 'SET_EMAIL',
        storeShouldRegister: 'SET_SHOULD_REGISTER',
        storeGuestPassword: 'SET_REGISTRATION_PASSWORD',
    })), mapMutations('blue', {
        setValidCartState: 'SET_VALID_CART',
    })), { changeShowBillingAddress() {
            this.resetValidCartState();
            this.toggleBillingAddressUsage(this.use_billing_address);
        },
        togglePasswordFieldToRegisterAccount() {
            this.storeShouldRegister(!this.shouldRegister);
        },
        saveEmail() {
            this.storeEmail(this.edit_email);
        },
        saveValidGuestPassword(changedEventWithMeta) {
            if (changedEventWithMeta.valid) {
                this.storeGuestPassword(changedEventWithMeta.value);
            }
        } }),
    watch: {
        useBillingAddress() {
            if (this.useBillingAddress !== null) {
                this.use_billing_address = this.useBillingAddress;
            }
        },
        shippingAddress() {
            this.edit_shipping_address = null;
        },
        billingAddress() {
            this.edit_billing_address = null;
        },
    },
});
